var map = {
	"./svg/icons/arrow_left.svg": 3556,
	"./svg/icons/arrow_right.svg": 219,
	"./svg/icons/arrows_up_down.svg": 9272,
	"./svg/icons/calendar.svg": 3060,
	"./svg/icons/caret_down.svg": 9221,
	"./svg/icons/caret_left.svg": 5166,
	"./svg/icons/caret_right.svg": 5677,
	"./svg/icons/check.svg": 1691,
	"./svg/icons/edit_dots.svg": 7304,
	"./svg/icons/error.svg": 8029,
	"./svg/icons/filetype_folder.svg": 3766,
	"./svg/icons/filetype_generated.svg": 2097,
	"./svg/icons/filetype_group.svg": 7583,
	"./svg/icons/filetype_set.svg": 6606,
	"./svg/icons/filetype_single_image.svg": 2004,
	"./svg/icons/filetype_single_pdf.svg": 8005,
	"./svg/icons/filetype_single_video.svg": 4126,
	"./svg/icons/home.svg": 532,
	"./svg/icons/hourglass.svg": 9029,
	"./svg/icons/info.svg": 7865,
	"./svg/icons/list.svg": 3909,
	"./svg/icons/logout.svg": 8619,
	"./svg/icons/menu_apps.svg": 3231,
	"./svg/icons/menu_bibliothek.svg": 5122,
	"./svg/icons/menu_generator.svg": 2598,
	"./svg/icons/menu_playlists.svg": 3136,
	"./svg/icons/menu_screens.svg": 634,
	"./svg/icons/menu_settings.svg": 4384,
	"./svg/icons/menu_users.svg": 841,
	"./svg/icons/selectTriangle.svg": 7521,
	"./svg/icons/sorting.svg": 1803,
	"./svg/icons/success.svg": 2110,
	"./svg/icons/tiles.svg": 5592,
	"./svg/icons/times.svg": 5477,
	"./svg/icons/trash.svg": 297,
	"./svg/icons/warning.svg": 9251
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;